import { auth0Config } from "@aceso/config";
import { getStoredClientID, getOrgID } from "@aceso/utils/localStorageHelper";
import { getClusterAPIEndpoint } from "@aceso/utils/getClusterInfo";
import axios from "@aceso/utils/axios";
export const openPopup = () => {
  const width = 400;
  const height = 600;
  const left = window.screenX + (window.innerWidth - width) / 2;
  const top = window.screenY + (window.innerHeight - height) / 2;

  return window.open(
    "",
    "auth0:authorize:popup",
    `left=${left},top=${top},width=${width},height=${height},resizable,scrollbars=yes,status=1`
  );
};

export const generateAuthUrl = () => {
  const clientId = getStoredClientID();
  const domain = auth0Config.domain;
  const redirectUri = encodeURIComponent(window.location.origin);
  const responseType = "token";
  const scope = "openid profile email";

  return `https://${domain}/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}`;
};
export const isIOS = () => {
  const isNavigatorAvailable = typeof navigator !== "undefined";
  if (isNavigatorAvailable) {
    const isIOSDevice = /iPad|iPhone|iPod/i.test(navigator.userAgent);
    return isIOSDevice;
  }
  return false;
};

// Fetches the signed-in user's own Auth0 profile and org roles via the
// server-side proxy. The Management API token never reaches the browser.
export const fetchAuth0Me = async (accessToken) => {
  try {
    const { data } = await axios.request({
      method: "GET",
      url: "/api/auth0/me",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return data;
  } catch (error) {
    console.error("Error fetching Auth0 profile:", error);
    throw new Error("Failed to fetch user profile.");
  }
};

// Helper function to create user in healthcare db
export const createUserInHealthcare = async (
  user,
  roleId,
  organization,
  accessToken
) => {
  const auth0Id = user?.sub || user?.user_id || user?.userId;
  const username =
    user?.name ||
    user?.nickname ||
    user?.email ||
    user?.preferred_username ||
    auth0Id;

  try {
    const { data } = await axios.request({
      method: "POST",
      url: `${getClusterAPIEndpoint()}/users`,
      headers: {
        "content-type": "application/json",
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      data: {
        email: user?.email,
        username,
        auth0_id: auth0Id,
        auth0_role_id: roleId,
        organization_id: organization,
        joining_date: new Date().toISOString().split("T")[0],
      },
    });

    return data;
  } catch (error) {
    console.error("Error creating user in healthcare:", error);
    throw new Error("Failed to create user in healthcare.");
  }
};

// Helper function to assign the relative to resident
export const assignResidentToRelative = async (
  detailedUser,
  healthcareUser
) => {
  try {
    if (
      detailedUser.app_metadata &&
      detailedUser.app_metadata.assigned_resident
    ) {
      const assignedResident = detailedUser.app_metadata.assigned_resident;

      localStorage.setItem("assigned", assignedResident);

      const healthcareRelativeAssignment = await axios.request({
        method: "POST",
        url: `${getClusterAPIEndpoint()}/residents/${assignedResident}/relatives`, // Replace with actual external API URL
        headers: {
          "content-type": "application/json",
        },
        data: {
          user_id: healthcareUser?.id,
        },
      });

      return healthcareRelativeAssignment.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error in assigned resident flow:", error);
    throw error;
  }
};

// Helper function to handle resident assignment
export const handleAssignedResident = async (detailedUser, healthcareUser) => {
  if (
    detailedUser?.app_metadata &&
    detailedUser?.app_metadata?.assigned_resident
  ) {
    const assignedResidentData = await assignResidentToRelative(
      detailedUser,
      healthcareUser
    );
    return assignedResidentData;
  }
};
